<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="evaluation_exam_definition_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('evaluation_type')">
                            <evaluation-exam-definition-selectbox v-model="formData.evaluation_exam_definition_id"
                                                                  :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="graduate_application_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student')">
                            <b-form-input v-model="formData.graduate_application_name" :disabled="true" :validateError="errors[0]" />
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="score" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('score')">
                            <b-form-input v-model="formData.score" :validate-error="errors[0]"/>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
// Components
import EvaluationExamDefinitionSelectbox from "@/components/interactive-fields/EvaluationExamDefinitionSelectbox.vue";
// Services
import GraduateApplicationEvaluationExamsService from "@/services/GraduateApplicationEvaluationExamsService";
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        EvaluationExamDefinitionSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                graduate_application_id: null,
                evaluation_exam_definition_id: null,
                score: null,
                graduate_application_name: null
            },
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            GraduateApplicationEvaluationExamsService.get(id)
                         .then(response => {
                             let data = response.data.data;
                             this.formData = {
                                 graduate_application_id:data.graduate_application_id,
                                 evaluation_exam_definition_id:data.evaluation_exam_definition_id,
                                 score:data.score,
                                 graduate_application_name: data.graduate_application.name + " " + data.graduate_application.surname,
                             }
                         })
                         .catch(e => {
                             this.showErrors(e, this.$refs.formModalValidate);
                         })
        },

        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;
                GraduateApplicationEvaluationExamsService.update(this.formId, this.formData)
                             .then(response => {
                                 this.$emit('updateFormSuccess', true);
                                 this.$toast.success(this.$t('api.' + response.data.message));
                             })
                             .catch(e => {
                                 this.showErrors(e, this.$refs.formModalValidate);
                             })
                             .finally(() => {
                                 this.formLoading = false
                             })
            }
        }
    }
}
</script>
